module.exports = __webpack_public_path__ + "static/media/home_banner2.69eb0540.png";